import { useEffect } from 'react'

import { useAuth } from '../auth/AuthProvider'
import { api } from '../lib/api'
import { captureAttribution, syncAttribution } from '../lib/attribution'

// Remembers where the visitor came from on the first page they open, and sends it once they are
// signed in. The server refuses until the 152-ФЗ consent is on record; then the next load retries.
export default function AttributionSync() {
  const { authenticated, userInfo } = useAuth()
  const userKey = userInfo?.sub || ''

  useEffect(() => {
    captureAttribution()
  }, [])

  useEffect(() => {
    if (!authenticated || !userKey) return
    void syncAttribution(userKey, (first, last) => api.saveAttribution(first, last))
  }, [authenticated, userKey])

  return null
}
